export const SampleMethodologySearch = `/SampleMethodology/search`;  
export const SampleMethodology = `/SampleMethodology`;  